module.exports = __webpack_public_path__ + "static/media/ver.a82c5af5.png";